import { Text2, skinVars } from '@telefonica/mistica';
import { IProblemResponse } from '../../models/Problems.interfaces';

const ChatDynamicResponse = ({ responses, onSelected }: { responses: IProblemResponse[]; onSelected: Function }) => {
    const handleResponse = (response: IProblemResponse) => {
        onSelected(response);
    };

    return (
        <>
            {responses?.map((response: IProblemResponse) => {
                const { text } = response;
                return (
                    <div
                        key={response.id}
                        onClick={() => handleResponse(response)}
                        className='chat-response'
                        style={{
                            borderStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: skinVars.colors.controlActivated,
                        }}
                    >
                        <Text2 regular color={skinVars.colors.textLink}>
                            {text}
                        </Text2>
                    </div>
                );
            })}
        </>
    );
};

export default ChatDynamicResponse;
